<div class="wrapper">
  @if (data$ | async; as data) {
    <form [formGroup]="form">
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        subscriptSizing="dynamic"
        >
        <mat-select formControlName="localeId">
          @for (locale of data.locales; track locale) {
            <mat-option [value]="locale.id">{{
              locale.nativeName
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  }
</div>
